import { Validators } from "@angular/forms";
import {
  IDepartment,
  IDepartmentParams,
} from "@app/shared/data-access/src/lib/resource-management/models/department";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
} from "@app/shared/ui-lib/src/lib";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";

export class DepartmentConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Department;
  isCrudByModal = true;
  title = "dicTable.departments";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "group",
      title: "dicTable.group",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.Group,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
    {
      title: "dicTable.sortOrder",
      name: "sortOrder",
      type: HardFormFieldTypeEnum.Number,
    },
  ];

  saveCallback(data: IDepartment): IDepartment {
    const groupId = data?.group?.id;
    delete data?.group;

    return {
      ...data,
      groupId,
    };
  }

  filterTemplateColumns = "1fr 200px";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
    {
      name: "group",
      type: HardFormFieldTypeEnum.Dictionary,
      placeholder: "dicTable.allGroups",
      outside: true,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.Group,
      } as IHardFormSelectParams,
    },
  ];

  filterCallback(data: IDepartmentParams): IDepartmentParams {
    return {
      searchTerm: data?.searchTerm ?? "",
      groupId: data?.group?.id ?? null,
    };
  }

  tableConfig: ITable<IDepartment[]> = {
    showDefaultActions: true,
    tableColumns: "40px repeat(4,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },

      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.code",
        name: "code",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.groupName",
        name: "name",
        type: HardTableColumnTypeEnum.Parent,
        parent: "group",
      },
    ],
  };
}
